import { render, staticRenderFns } from "./PhasesUsersView.vue?vue&type=template&id=1396087e&scoped=true"
import script from "./PhasesUsersView.vue?vue&type=script&lang=ts"
export * from "./PhasesUsersView.vue?vue&type=script&lang=ts"
import style0 from "./PhasesUsersView.vue?vue&type=style&index=0&id=1396087e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1396087e",
  null
  
)

export default component.exports